import script from "./masterGrid.vue?vue&type=script&lang=js"
export * from "./masterGrid.vue?vue&type=script&lang=js"

import "./masterGrid.vue?vue&type=style&index=0&id=1c8992a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c8992a2"]])

export default __exports__